// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { cartTotalDisplayStyles } from "@guestsupply/Overrides/Components/CartTotalDisplay";
import Help from "@guestsupply/XDL/Icons/Help";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    ...cartSummarySharedStyles.container,
};
cartTotalDisplayStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
cartTotalDisplayStyles.titleText = {
    ...cartSummarySharedStyles.titleText,
};
cartTotalDisplayStyles.dividerGridItem = {
    ...mergeWithCss(cartSummarySharedStyles.dividerGridItem, {
        css: css`
            &&& {
                border-top: 1px solid ${getColor("common.border")};
                margin: 0 9px;
                margin-top: 8px;

                ${({ displayDivider }: any) =>
                    css`
                        border-top: ${displayDivider};
                    `}
            }
        `,
    }),
};
cartTotalDisplayStyles.labelGridItem = { ...cartSummarySharedStyles.labelGridItem };
cartTotalDisplayStyles.valueGridItem = { ...cartSummarySharedStyles.valueGridItem };
cartTotalDisplayStyles.totalLabelGridItem = {
    width: 6,
};
cartTotalDisplayStyles.totalValueGridItem = { width: 6 };
cartTotalDisplayStyles.subtotalValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.promotionValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.discountsValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.otherChargesValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.taxValue = {
    ...cartSummarySharedStyles.valueText,
};
cartTotalDisplayStyles.totalLabel = {
    ...cartSummarySharedStyles.totalLabel,
};
cartTotalDisplayStyles.totalValue = {
    ...cartSummarySharedStyles.totalValue,
};
// OOTB Style
cartTotalDisplayStyles.loadingSpinner = {
    size: 15,
    css: css`
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    `,
};
cartTotalDisplayStyles.subtotalLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartTotalDisplayStyles.promotionLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartTotalDisplayStyles.discountsLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...mergeWithCss(cartSummarySharedStyles.labelText, {
        css: css`
            display: flex;
            align-items: center;
        `,
    }),
};
cartTotalDisplayStyles.icon = {
    size: 12,
    src: Help,
    color: "primary",
    css: css`
        margin-left: 8px;
        opacity: 0.33;
    `,
};
cartTotalDisplayStyles.otherChargesLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartTotalDisplayStyles.taxLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartTotalDisplayStyles.wrapper = {
    css: css``,
};
cartTotalDisplayStyles.additionalShippingChargesTypography = {
    size: 10,
    lineHeight: "16px",
    css: css`
        margin: 0 9px 13px;
        font-style: italic;
        &::before {
            content: "*";
        }
    `,
};
cartTotalDisplayStyles.standardFreightLabel = {
    ...cartSummarySharedStyles.labelText,
    size: 11,
};
cartTotalDisplayStyles.standardFreightValue = {
    ...cartSummarySharedStyles.valueText,
    size: 11,
};
cartTotalDisplayStyles.tooltipStyles = {
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            margin-left: 8px;
            margin-right: 0;
            ${IconWrapper} {
                top: 0;
            }
            svg {
                height: 12px;
                width: 12px;
            }
        `,
    },
};
cartTotalDisplayStyles.shippingAndHandlingTypography = {
    css: css`
        ${xScreen("lte", "md")} {
            max-width: 90px;
        }
        ${xScreen("lte", "sm")} {
            max-width: inherit;
        }
    `,
};
